// GET PROMOTION DETAIL
export const GET_PROMOTION_DETAIL = 'GET_PROMOTION_DETAIL';
export const GET_PROMOTION_DETAIL_SUCCESS = 'GET_PROMOTION_DETAIL_SUCCESS';
export const GET_PROMOTION_DETAIL_FAILED = 'GET_PROMOTION_DETAIL_FAILED';

// GET PROMOTION LIST
export const GET_PROMOTION_LIST = 'GET_PROMOTION_LIST';
export const GET_PROMOTION_LIST_SUCCESS = 'GET_PROMOTION_LIST_SUCCESS';
export const GET_PROMOTION_LIST_FAILED = 'GET_PROMOTION_LIST_FAILED';

// CREATE BASIC PROMOTION
export const CREATE_PROMOTION = 'CREATE_PROMOTION';
export const CREATE_PROMOTION_SUCCESS = 'CREATE_PROMOTION_SUCCESS';
export const CREATE_PROMOTION_FAILED = 'CREATE_PROMOTION_FAILED';

// EDIT BASIC PROMOTION
export const EDIT_PROMOTION = 'EDIT_PROMOTION';
export const EDIT_PROMOTION_SUCCESS = 'EDIT_PROMOTION_SUCCESS';
export const EDIT_PROMOTION_FAILED = 'EDIT_PROMOTION_FAILED';

// DELETE BASIC PROMOTION
export const DELETE_PROMOTION = 'DELETE_PROMOTION';
export const DELETE_PROMOTION_SUCCESS = 'DELETE_PROMOTION_SUCCESS';
export const DELETE_PROMOTION_FAILED = 'DELETE_PROMOTION_FAILED';

// CLEAR PROMOTION DETAIL
export const CLEAR_PROMOTION_DETAIL = 'CLEAR_PROMOTION_DETAIL';

// CREATE PLACE PROMOTION
export const CREATE_PLACE_PROMOTION = 'CREATE_PLACE_PROMOTION';
export const CREATE_PLACE_PROMOTION_SUCCESS = 'CREATE_PLACE_PROMOTION_SUCCESS';
export const CREATE_PLACE_PROMOTION_FAILED = 'CREATE_PLACE_PROMOTION_FAILED';

// GET PLACE PROMOTION DETAIL
export const GET_PLACE_PROMOTION_DETAIL = 'GET_PLACE_PROMOTION_DETAIL';
export const GET_PLACE_PROMOTION_DETAIL_SUCCESS = 'GET_PLACE_PROMOTION_DETAIL_SUCCESS';
export const GET_PLACE_PROMOTION_DETAIL_FAILED = 'GET_PLACE_PROMOTION_DETAIL_FAILED';

// CLEAR PLACE PROMOTION DETAIL
export const CLEAR_PLACE_PROMOTION_DETAIL = 'CLEAR_PLACE_PROMOTION_DETAIL';

// DELETE PLACE PROMOTION
export const DELETE_PLACE_PROMOTION = 'DELETE_PLACE_PROMOTION';
export const DELETE_PLACE_PROMOTION_SUCCESS = 'DELETE_PLACE_PROMOTION_SUCCESS';
export const DELETE_PLACE_PROMOTION_FAILED = 'DELETE_PLACE_PROMOTION_FAILED';

// GET PLACE PROMOTION LIST
export const GET_PLACE_PROMOTION_LIST = 'GET_PLACE_PROMOTION_LIST';
export const GET_PLACE_PROMOTION_LIST_SUCCESS = 'GET_PLACE_PROMOTION_LIST_SUCCESS';
export const GET_PLACE_PROMOTION_LIST_FAILED = 'GET_PLACE_PROMOTION_LIST_FAILED';

// DELETE PROMOTION DISCOUNT
export const DELETE_PROMOTION_DISCOUNT = 'DELETE_PROMOTION_DISCOUNT';
export const DELETE_PROMOTION_DISCOUNT_SUCCESS = 'DELETE_PROMOTION_DISCOUNT_SUCCESS';
export const DELETE_PROMOTION_DISCOUNT_FAILED = 'DELETE_PROMOTION_DISCOUNT_FAILED';

// GET USABLE MARKETING PROMOTION LIST
export const GET_USABLE_MARKETING_PROMOTION_LIST = 'GET_USABLE_MARKETING_PROMOTION_LIST';
export const GET_USABLE_MARKETING_PROMOTION_LIST_SUCCESS = 'GET_USABLE_MARKETING_PROMOTION_LIST_SUCCESS';
export const GET_USABLE_MARKETING_PROMOTION_LIST_FAILED = 'GET_USABLE_MARKETING_PROMOTION_LIST_FAILED';

// GET USABLE MARKETING PROMOTION DETAIL
export const GET_USABLE_MARKETING_PROMOTION_DETAIL = 'GET_USABLE_MARKETING_PROMOTION_DETAIL';
export const GET_USABLE_MARKETING_PROMOTION_DETAIL_SUCCESS = 'GET_USABLE_MARKETING_PROMOTION_DETAIL_SUCCESS';
export const GET_USABLE_MARKETING_PROMOTION_DETAIL_FAILED = 'GET_USABLE_MARKETING_PROMOTION_DETAIL_FAILED';
export const CLEAR_USABLE_MARKETING_PROMOTION_DETAIL = 'CLEAR_USABLE_MARKETING_PROMOTION_DETAIL';
